import React from 'react';
import { Navigate } from 'react-router';

export type AccessDecision = 'loading' | 'allow' | 'deny';

export const toAccessDecision = (isChecking: boolean, hasAccess: boolean | null): AccessDecision =>
  isChecking ? 'loading' : !hasAccess ? 'deny' : 'allow';

type PermissionGuardProps = {
  decision: AccessDecision;
  children: React.ReactNode;
};

export const PermissionGuard = ({ decision, children }: PermissionGuardProps): React.ReactNode => {
  if (decision === 'loading') return null;
  if (decision === 'deny') return <Navigate to='/' replace />;
  return children;
};
